import type {
  TransactionType,
  WireWithdrawal,
  WireReceive,
  SenWithdrawal,
  SenReceive,
  OnchainSend,
  OnchainReceive,
  SignetReceive,
  SignetWithdrawal,
  CbitReceive,
  CbitWithdrawal,
  XpayReceive,
  XpayWithdrawal,
  RtpReceive,
  RtpWithdrawal,
  SepaReceive,
  SepaWithdrawal,
  SepaInstantReceive,
  SepaInstantWithdrawal,
  GrossRedemptionFee,
  NetRedemptionFee,
  SettlementCreditFee,
  SettlementCreditReceive,
  CubixReceive,
  CubixWithdrawal,
  PixWithdrawal,
  PixReceive,
} from '@shared/graphql'

// Type mapping between transaction types and their corresponding PaymentDetails type
type PaymentDetailsTypeMap = {
  [TransactionType.wire_withdrawal]: WireWithdrawal
  [TransactionType.wire_receive]: WireReceive
  [TransactionType.sen_withdrawal]: SenWithdrawal
  [TransactionType.sen_receive]: SenReceive
  [TransactionType.onchain_send]: OnchainSend
  [TransactionType.onchain_receive]: OnchainReceive
  [TransactionType.signet_receive]: SignetReceive
  [TransactionType.signet_withdrawal]: SignetWithdrawal
  [TransactionType.cbit_receive]: CbitReceive
  [TransactionType.cbit_withdrawal]: CbitWithdrawal
  [TransactionType.xpay_receive]: XpayReceive
  [TransactionType.xpay_withdrawal]: XpayWithdrawal
  [TransactionType.rtp_receive]: RtpReceive
  [TransactionType.rtp_withdrawal]: RtpWithdrawal
  [TransactionType.sepa_withdrawal]: SepaWithdrawal
  [TransactionType.sepa_receive]: SepaReceive
  [TransactionType.sepa_instant_withdrawal]: SepaInstantWithdrawal
  [TransactionType.sepa_instant_receive]: SepaInstantReceive
  [TransactionType.redemption_fee_gross]: GrossRedemptionFee
  [TransactionType.redemption_fee_net]: NetRedemptionFee
  [TransactionType.settlement_credit_fee]: SettlementCreditFee
  [TransactionType.settlement_credit_receive]: SettlementCreditReceive
  [TransactionType.settlement_credit_overrepayment_refund]: SettlementCreditReceive
  [TransactionType.cubix_receive]: CubixReceive
  [TransactionType.cubix_withdrawal]: CubixWithdrawal
  [TransactionType.pix_receive]: PixReceive
  [TransactionType.pix_withdrawal]: PixWithdrawal
  // Missing transaction types
  [TransactionType.rtgs_withdrawal]: never
  [TransactionType.rtgs_receive]: never
  [TransactionType.trade_mint]: never
  [TransactionType.trade_withdrawal]: never
  [TransactionType.convert_mint]: never
  [TransactionType.convert_withdrawal]: never
}

// Ensure that all transaction types are represented in the PaymentDetailsTypeMap
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type EnsureExhaustiveness = {
  [K in TransactionType]: PaymentDetailsTypeMap[K]
}

/**
 * Typeguard for PaymentDetails.
 * @param details - Union payment details.
 * @param type - Transaction type.
 */
export function isPaymentDetails<T extends keyof PaymentDetailsTypeMap>(
  details: PaymentDetailsTypeMap[keyof PaymentDetailsTypeMap] | undefined,
  type: T,
): details is PaymentDetailsTypeMap[T] {
  return details?.payment.type === type
}
